import IconMi from 'components/common/icon/IconMi';
import React from 'react';
import { Box, Stack } from '@mui/material';
import { toast } from 'sonner';
import useBundleTranslation from 'i18n';
import styles from './Toast.styles';

export type ToastType = 'success' | 'error' | 'warning' | 'info';
interface ToastProps {
    id: string | number;
    type: ToastType;
    title?: string;
    description?: string;
    button?: {
        label: string;
        onClick: () => void;
    };
    html?: boolean;
}

const iconsAlias = {
    success: 'success',
    error: 'alert',
    info: 'info-circle',
    warning: 'info-circle',
};

export default function Toast({ title, type, description, id, html }: ToastProps) {
    const { t } = useBundleTranslation();
    const handleCLose = () => {
        toast.dismiss(id);
    };

    const titleLabel = title ?? t(type);
    return (
        <Stack className={`toast-item toast-item--type-${type}`} direction={'row'} sx={styles.toastItem}>
            <Box className={'toast-item__icon'} sx={styles.toastItemIcon}>
                <IconMi icon={iconsAlias[type] ?? 'info'} />
            </Box>
            <Box className={'toast-item__content'} sx={styles.toastItemContent}>
                {html ? (
                    <>
                        <Box
                            dangerouslySetInnerHTML={{ __html: titleLabel }}
                            className={'toast-item__title'}
                            sx={styles.toastItemTitle}
                        />
                        <Box
                            dangerouslySetInnerHTML={{ __html: description ?? '' }}
                            className={'toast-item_desc'}
                            sx={styles.toastItemDesc}
                        />
                    </>
                ) : (
                    <>
                        <Box className={'toast-item__title'} sx={styles.toastItemTitle}>
                            {titleLabel}
                        </Box>
                        <Box className={'toast-item_desc'} sx={styles.toastItemDesc}>
                            {description}
                        </Box>
                    </>
                )}
            </Box>
            <Box sx={styles.toastItemCloseBtn} onClick={handleCLose}>
                <IconMi icon="times" />
            </Box>
        </Stack>
    );
}
